"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

/**
 * Vrati query part pre vyhladavanie textu bez diakritiky s ciastocnou shodou aspon jedneho chunku.
 *
 * Pokial `value` obsahuje medzery bude rozdelene na chunky. K zhode dojde v pripade, ze cielovy
 * text obsahuje aspon jeden z chunkov. V cielovych textoch sa hlada ciastocna zhoda chunku.
 *
 * Priklad: 'krá dum' =$search=> 'kraso videna' | 'krasavice nase' | 'plny dum' | 'dumxxx'
 *
 * Je vhodne pri vyhladavani v ciselnikoch.
 *
 * @param {string} fieldName
 * @param {string} value
 */
var textSearchToQuery = function textSearchToQuery(fieldName, value) {
  return value === undefined ? undefined : (0, _defineProperty2.default)({}, fieldName, {
    $search: value
  });
};

var _default = textSearchToQuery;
exports.default = _default;